import { render, staticRenderFns } from "./Permission.vue?vue&type=template&id=de68158e&scoped=true&"
import script from "./Permission.vue?vue&type=script&lang=js&"
export * from "./Permission.vue?vue&type=script&lang=js&"
import style0 from "./Permission.vue?vue&type=style&index=0&id=de68158e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de68158e",
  null
  
)

export default component.exports